import React, { useState, useEffect, useRef } from 'react';
import {
  oneOfType, instanceOf, arrayOf, string, node
} from 'prop-types';
import { Row, Button } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { useClickOutside } from '../../../hooks/useClickOutside';
import styles from './accordion.module.scss';

const classes = classNames.bind(styles);

const Accordion = ({ dimensions }) => {

  const [currentDimension, setCurrentDimension] = useState(null);
  const [dimensionsAsMap, setDimensionsAsMap] = useState(dimensions instanceof Map ? dimensions : new Map(dimensions));
  useEffect(() => {
    setDimensionsAsMap(dimensions instanceof Map ? dimensions : new Map(dimensions));
  }, [dimensions]);

  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, () => {
    setCurrentDimension(null);
  });

  return (
    <div className="grid accordion" ref={wrapperRef}>
      <div className={classes('accordion__labels')}>
        {
          Array.from(dimensions).map(([dimensionLabel, dimensionView], index) => {
            const isDisabled = dimensionView === null;
            const isOpen = !isDisabled && currentDimension && dimensionLabel === currentDimension;
            const openArrowClasses = classes(
              'accordion__labels__caret',
              { 'accordion__labels__caret--open': isOpen });
            const colClasses = classes('accordion__labels__col',
              {
                'accordion__labels__col--bold': currentDimension && dimensionLabel === currentDimension,
                'accordion__labels__col--isDisabled': isDisabled
              });
            return (
              <div
                // reordering won't occur so using i for key is fine.
                // An alternative is key={ReactDOMServer.renderToString(dimensionLabel)}
                key={index}
                className={colClasses}
              >
                <Button
                  className={`${classes('accordion__labels__link')} _label`}
                  link
                  tag="a"
                  onClick={(event) => {
                    event.preventDefault();
                    setCurrentDimension(currentDimension === dimensionLabel ? null : dimensionLabel);
                  }}
                >
                  <span className={classes('accordion__labels__label')}>
                    {dimensionLabel}
                  </span>

                  <img
                    alt="open arrow"
                    className={openArrowClasses}
                    src="https://assets.thdstatic.com/images/v1/caret-orange.svg"
                    height="15"
                    width="9"
                  />
                </Button>
              </div>
            );
          })
        }
      </div>
      {currentDimension && (
        <Row>
          {dimensionsAsMap.get(currentDimension)}
        </Row>
      )}

    </div>
  );
};

Accordion.displayName = 'Accordion';

Accordion.propTypes = {
  dimensions: oneOfType([
    instanceOf(Map),
    arrayOf(
      arrayOf(
        oneOfType([string, node]) // node can be null, which will disable the dropdown
      )
    )
  ]).isRequired
};

export { Accordion };
